<span>
  @if (icon && iconPos === positionEnum.left) {
    <sd-icon [brand]="brand" [name]="icon" [size]="isIcon ? iconSize.medium : iconSize.small" />
  }

  @if (image && imagePos === positionEnum.left) {
    <img [src]="image" class="has-margin-right" [ngClass]="{ 'is-rounded': isRoundedImage }" [alt]="brand" />
  }

  <ng-content />

  @if (icon && iconPos === positionEnum.right) {
    <sd-icon [brand]="brand" [name]="icon" [size]="isIcon && !isSmall ? iconSize.medium : iconSize.small" />
  }

  @if (image && imagePos === positionEnum.right) {
    <img [src]="image" class="has-margin-left" [ngClass]="{ 'is-rounded': isRoundedImage }" [alt]="brand" />
  }
</span>
